import { LOAD_PLANT_PRODUCTS, SAVE_PLANT_PRODUCTS, EXPORT_PLANT_PRODUCTS, IMPORT_PLANT_PRODUCTS } from "./actions";

const msg = {
  success_msg: "",
  err_msg: "",
  import_err_msg: "",
};

const initialState = {
  data: [],
  loading: false,
  shouldReload: false,
  ...msg,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_PLANT_PRODUCTS.REQUEST:
      return {
        ...state,
        ...msg,
        loading: true,
        shouldReload: false,
      };

    case LOAD_PLANT_PRODUCTS.SUCCESS:
      return {
        ...state,
        data: action.payload.data.data,
        loading: false,
      };

    case SAVE_PLANT_PRODUCTS.REQUEST:
      return {
        ...state,
        ...msg,
        loading: true,
      };

    case SAVE_PLANT_PRODUCTS.SUCCESS:
      return {
        ...state,
        success_msg: "save_success",
        loading: false,
      };

    case EXPORT_PLANT_PRODUCTS.REQUEST:
    case IMPORT_PLANT_PRODUCTS.REQUEST:
      return { ...state, ...msg, loading: true };

    case EXPORT_PLANT_PRODUCTS.SUCCESS:
      return { ...state, loading: false };

    case IMPORT_PLANT_PRODUCTS.SUCCESS:
      return { ...state, loading: false, success_msg: "import_success" };

    case LOAD_PLANT_PRODUCTS.FAILURE:
    case SAVE_PLANT_PRODUCTS.FAILURE:
    case EXPORT_PLANT_PRODUCTS.FAILURE:
      return {
        ...state,
        err_msg: action.payload.err,
        loading: false,
        shouldReload: false,
      };

    case IMPORT_PLANT_PRODUCTS.FAILURE:
      return {
        ...state,
        import_err_msg: action.payload.err,
        loading: false,
      };

    default:
      return state;
  }
};
